import type { EntityDataObject, EntityReferenceDataObject } from './service';

export type EntityReference = {
  id: string;
};

export class Entity implements EntityReference {
  id: string;
  name: string;

  constructor(data: EntityDataObject) {
    this.id = data.id;
    this.name = data.name;
  }
}

export const createEntityReference = (data: EntityReferenceDataObject): EntityReference => ({
  id: data.id,
});

export const createEntity = (data: EntityDataObject): Entity => ({
  ...createEntityReference(data),
  name: data.name,
});
